module.exports = __webpack_public_path__ + "img/项目管理.b669d6e2.png";